<template>
  <div>
    <div class="phone-selector-container-mobile">
      <div class="col" style="margin-bottom: 2rem;" v-if="$whitelabel.showLogo()">
        <img :src="require('../../../assets/sqrql_logo.png')" width="160px" height="160px">
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem; min-height: 222px;" v-if="processing">
        <b-spinner variant="teal" label="Spinning"></b-spinner>
      </div>
      <div class="col-12" style="margin-top: 3rem; margin-bottom: 3rem;" v-else>
        <div class="col-12" style="min-height: 60px;">
          <b-alert variant="danger" :show="isAlert">{{ alert }}</b-alert>
          <b-alert variant="success" :show="isSuccess">{{ successMessage }}</b-alert>
        </div>
        <form method="post" @submit.prevent="reset" name="reset">
          <div class="col-12">
            <div class="col-12">
              <b-form-input
                id="username"
                v-model="username"
                type="text"
                required
                placeholder="Username"
              ></b-form-input>
            </div>
          </div>
          <div class="col-10 offset-1" style="margin-top: 2rem;">
            <b-button variant="primary" type="submit" block style="background-color: #009AB1; border-color: #009AB1;">Send Reset Link</b-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'reset-email',
    mounted () {
      localStorage.removeItem('fonestorm-token')
      localStorage.removeItem('device')
    },
    data () {
      return {
        username: '',
        alert: 'Username or Password doesn\'t match',
        isAlert: false,
        processing: false,
        isSuccess: false,
        successMessage: 'Password Reset email has been sent to your email.'
      }
    },
    methods: {
      reset: async function () {
        var self = this
        try {
          if (self.username) {
            // eslint-disable-next-line
            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/

            if (filter.test(self.username)) {
              self.processing = true
              self.isAlert = false
              await axios.post(`${process.env.MYR_ROOT}/password_resets?email=${self.username}&template=fractelfone`, {})
              self.processing = false
              self.isSuccess = true
            } else {
              self.isAlert = true
              self.processing = false
              self.alert = 'Please contact your Administrator to reset your password.'
            }
          }
        } catch (error) {
          self.isAlert = true
          self.processing = false
          self.isSuccess = false
        }
      }
    }
  }
</script>

<style scopped>
.phone-selector-container-mobile {
  background-color: white;
  padding: 20px !important;
  margin: 0 auto 0 auto !important;
  overflow: hidden;
  text-align: center !important;
}
.text-teal {
  color: #009AB1;
}
</style>
